// Show more button Fondation page
const showMoreBtn = document.querySelectorAll(".show_more_btn");
const excerptContent = document.getElementsByClassName("excerpt_content");
const fullContent = document.getElementsByClassName("full_content");

const showText = document.getElementsByClassName("show");
const hideText = document.getElementsByClassName("hide");

if (fullContent.length !== 0 ) {
    for (let index = 0; index < showMoreBtn.length; index++) {
        showMoreBtn[index].addEventListener("click", function () {
            showMoreBtn[index].classList.toggle("active");
            excerptContent[index].classList.toggle("hidden-content");
            fullContent[index].classList.toggle("hidden-content");

            if (showMoreBtn[index].classList.contains("active")) {
                let hideTextContent = hideText[0].textContent;
                showMoreBtn[index].innerHTML = hideTextContent;
            } else {
                let showTextContent = showText[0].textContent;
                showMoreBtn[index].innerHTML = showTextContent;
            }
        })
    }

}
